import React from "react";

import { SkeletonBlock } from "@zapier/design-system";

export const Skeleton = () => <SkeletonBlock height={256} width="100%" />;
